import { createFileRoute } from '@tanstack/react-router';
import { JobPipelinesPage } from './job-pipelines/index';

export const Route = createFileRoute('/_dashboard/dashboard/settings/job-pipelines')({
  component: JobPipelinesLayout,
});

function JobPipelinesLayout() {
  return <JobPipelinesPage />;
}
